import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-mecs-home-page',
  templateUrl: './mecs-home-page.component.html',
  styleUrls: ['./mecs-home-page.component.scss'],
})
export class MecsHomePageComponent implements OnInit {
  showSpinner = false;

  constructor(
    private router: Router, 
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {}

  openMecsDashboard() {
    this.router.navigate(['dashboard'], {relativeTo: this.route})
  }
}
